
export default function CertificationsSection() {
  const certifications = [
    {
      title: '普洱茶年份茶全国销量第一品牌',
      issuer: '尚普咨询权威认证',
      year: '2020-2024',
      icon: 'ri-trophy-fill',
      color: 'from-yellow-400 to-yellow-600',
      description: '连续五年荣获全国销量第一，市场占有率遥遥领先',
      image: 'https://public.readdy.ai/ai/img_res/068757bd2fc2ed80ac9cdc4b89c07832.jpg'
    },
    {
      title: '国宾伴手礼认证',
      issuer: '丝路沿线国家指定',
      year: '2023',
      icon: 'ri-medal-fill',
      color: 'from-red-400 to-red-600',
      description: '丝路沿线多国指定的国宾级伴手礼，彰显国际认可',
      image: 'https://readdy.ai/api/search-image?query=Official%20diplomatic%20gift%20certificate%20for%20Chinese%20tea%20products%2C%20prestigious%20government%20recognition%20document%20with%20national%20emblems%20and%20formal%20seals%2C%20elegant%20ceremonial%20presentation%20with%20red%20ribbon%20and%20gold%20lettering%2C%20professional%20institutional%20award%20photography&width=400&height=300&seq=cert-2&orientation=landscape'
    },
    {
      title: '七星茶王奖',
      issuer: '中国茶叶协会',
      year: '2023',
      icon: 'ri-star-fill',
      color: 'from-purple-400 to-purple-600',
      description: '茶叶行业最高荣誉，代表产品品质的顶级认可',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20tea%20association%20seven-star%20tea%20king%20award%20trophy%2C%20prestigious%20golden%20trophy%20with%20star%20design%20and%20purple%20ribbon%2C%20professional%20award%20ceremony%20photography%20with%20elegant%20ceremonial%20presentation%2C%20traditional%20Chinese%20tea%20elements%20and%20modern%20luxury%20aesthetic&width=400&height=300&seq=cert-3&orientation=landscape'
    },
    {
      title: 'PICC产品责任险承保',
      issuer: '中国人民保险',
      year: '2021-至今',
      icon: 'ri-shield-check-fill',
      color: 'from-blue-400 to-blue-600',
      description: '中国人民保险承保，为产品质量提供全方位保障',
      image: 'https://readdy.ai/api/search-image?query=Professional%20insurance%20certificate%20from%20PICC%20for%20product%20liability%20coverage%2C%20official%20corporate%20insurance%20document%20with%20blue%20corporate%20colors%2C%20formal%20business%20certification%20with%20company%20logos%20and%20official%20stamps%2C%20professional%20documentation%20photography&width=400&height=300&seq=cert-4&orientation=landscape'
    },
    {
      title: '茶叶质量安全示范企业',
      issuer: '国家质检总局',
      year: '2022',
      icon: 'ri-award-fill',
      color: 'from-green-400 to-green-600',
      description: '国家质检总局认定的质量安全示范企业',
      image: 'https://readdy.ai/api/search-image?query=National%20quality%20inspection%20bureau%20tea%20safety%20demonstration%20enterprise%20certificate%2C%20official%20government%20quality%20award%20document%20with%20green%20accents%2C%20professional%20corporate%20recognition%20certificate%20with%20official%20seals%20and%20formal%20presentation%2C%20high-end%20business%20documentation&width=400&height=300&seq=cert-5&orientation=landscape'
    },
    {
      title: '云南省茶叶龙头企业',
      issuer: '云南省农业厅',
      year: '2021',
      icon: 'ri-building-2-fill',
      color: 'from-orange-400 to-orange-600',
      description: '云南省农业厅认定的茶叶行业龙头企业',
      image: 'https://readdy.ai/api/search-image?query=Yunnan%20provincial%20agriculture%20department%20leading%20tea%20enterprise%20certificate%2C%20official%20provincial%20government%20recognition%20document%20with%20orange%20ribbon%2C%20prestigious%20business%20award%20with%20regional%20authority%20seals%20and%20formal%20ceremonial%20presentation%2C%20professional%20corporate%20certification%20photography&width=400&height=300&seq=cert-6&orientation=landscape'
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="mx-auto px-6 lg:px-[15%]">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#663333] mb-4">
            权威认证
          </h2>
          <p className="text-sm sm:text-lg lg:text-xl text-gray-600 max-w-2xl mx-auto">
            多项国家级、行业级权威认证，见证我们在茶叶行业的卓越地位与品质承诺
          </p>
          <div className="w-24 h-1 bg-[#cc9966] mx-auto mt-6"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {certifications.map((cert, index) => (
            <div key={index} className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 overflow-hidden border border-gray-100">
              {/* 认证图片 */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={cert.image}
                  alt={cert.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 w-12 h-12 flex items-center justify-center bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-full shadow-lg">
                  <i className={`${cert.icon} text-lg text-white`}></i>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent h-20"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="inline-block bg-[#cc9966] text-white text-xs px-3 py-1 rounded-full font-medium">
                    {cert.year}
                  </span>
                </div>
              </div>

              {/* 认证信息 */}
              <div className="p-6 space-y-4">
                <h3 className="text-sm sm:text-lg lg:text-xl font-bold text-[#663333] leading-tight group-hover:text-[#cc9966] transition-colors">
                  {cert.title}
                </h3>
                
                <p className="text-xs sm:text-sm text-[#cc9966] font-semibold">
                  {cert.issuer}
                </p>
                
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                  {cert.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* 认证统计 */}
        <div className="mt-16 lg:mt-20 bg-gradient-to-r from-[#663333] to-[#774444] rounded-2xl p-8 lg:p-12 text-white">
          <h3 className="text-lg sm:text-xl lg:text-2xl xl:text-3xl font-bold text-center mb-8 lg:mb-12">
            权威认证数据
          </h3>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-[#cc9966] mb-2">15+</div>
              <div className="text-xs sm:text-base lg:text-lg text-gray-200">权威认证</div>
              <div className="text-xs text-gray-300 mt-1">Authority Certifications</div>
            </div>
            
            <div className="text-center">
              <div className="text-xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-[#cc9966] mb-2">50+</div>
              <div className="text-xs sm:text-base lg:text-lg text-gray-200">行业奖项</div>
              <div className="text-xs text-gray-300 mt-1">Industry Awards</div>
            </div>
            
            <div className="text-center">
              <div className="text-xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-[#cc9966] mb-2">5</div>
              <div className="text-xs sm:text-base lg:text-lg text-gray-200">国家级荣誉</div>
              <div className="text-xs text-gray-300 mt-1">National Honors</div>
            </div>
            
            <div className="text-center">
              <div className="text-xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-[#cc9966] mb-2">100%</div>
              <div className="text-xs sm:text-base lg:text-lg text-gray-200">质量合格率</div>
              <div className="text-xs text-gray-300 mt-1">Quality Pass Rate</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
